/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Message } from './message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
    MessageToJSONTyped,
} from './message';

/**
 * 
 * @export
 * @interface MessagePaginatedResponse
 */
export interface MessagePaginatedResponse {
    /**
     * Indicates if there are more pages to fetch.
     * @type {boolean}
     * @memberof MessagePaginatedResponse
     */
    hasMore: boolean;
    /**
     * Total number of elements across all pages.
     * @type {number}
     * @memberof MessagePaginatedResponse
     */
    totalElements: number | null;
    /**
     * The maximum number of elements in this page.
     * @type {number}
     * @memberof MessagePaginatedResponse
     */
    limit: number | null;
    /**
     * 
     * @type {Array<Message>}
     * @memberof MessagePaginatedResponse
     */
    messages: Array<Message>;
    /**
     * The offset of the first element in this page (for offset-based pagination). Either offset or last_sequence must be set.
     * @type {number}
     * @memberof MessagePaginatedResponse
     */
    offset?: number | null;
    /**
     * The sequence (or key) of the last element in this page (for key-based pagination). Either offset or last_sequence must be set.
     * @type {number}
     * @memberof MessagePaginatedResponse
     */
    lastSequence?: number | null;
}

/**
 * Check if a given object implements the MessagePaginatedResponse interface.
 */
export function instanceOfMessagePaginatedResponse(value: object): value is MessagePaginatedResponse {
    if (!('hasMore' in value) || value['hasMore'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    return true;
}

export function MessagePaginatedResponseFromJSON(json: any): MessagePaginatedResponse {
    return MessagePaginatedResponseFromJSONTyped(json, false);
}

export function MessagePaginatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessagePaginatedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasMore': json['has_more'],
        'totalElements': json['total_elements'],
        'limit': json['limit'],
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'offset': json['offset'] == null ? undefined : json['offset'],
        'lastSequence': json['last_sequence'] == null ? undefined : json['last_sequence'],
    };
}

export function MessagePaginatedResponseToJSON(json: any): MessagePaginatedResponse {
    return MessagePaginatedResponseToJSONTyped(json, false);
}

export function MessagePaginatedResponseToJSONTyped(value?: MessagePaginatedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'has_more': value['hasMore'],
        'total_elements': value['totalElements'],
        'limit': value['limit'],
        'messages': ((value['messages'] as Array<any>).map(MessageToJSON)),
        'offset': value['offset'],
        'last_sequence': value['lastSequence'],
    };
}

